/**
 * Quién entra en compras (proveedores, facturas de proveedor e informes): lo mismo que la `security` de la API
 * (`RolesInterface::ACCESO_COMPRAS`). El guard compara cada rol de forma exacta y sin jerarquía, así que
 * Superadmin se nombra aparte.
 */
export const ROLES_COMPRAS = 'ROLE_ADMINISTRACION, ROLE_ADMIN, ROLE_SUPERADMIN';
